import { render, staticRenderFns } from "./MetaboProject.vue?vue&type=template&id=53b05c68&scoped=true"
import script from "./MetaboProject.vue?vue&type=script&lang=js"
export * from "./MetaboProject.vue?vue&type=script&lang=js"
import style0 from "./MetaboProject.vue?vue&type=style&index=0&id=53b05c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b05c68",
  null
  
)

export default component.exports